import { Observable, filter, map, of, take, tap } from 'rxjs';
import { AssignedToService, Assignee } from './assigned-to-service-interface';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ConfigService } from '../../services/config.service';

export const AssignUserPersistenceIJ = new InjectionToken(
  'AssignUserPersistenceIJ'
);

export interface AssignUserPersistenceService {
  saveAssignee(assignee: Assignee): Observable<void>;
  removeAssignee(): Observable<void>;
}

@Injectable()
export class AssignToUserService implements AssignedToService {
  constructor(
    private configService: ConfigService,
    @Inject(AssignUserPersistenceIJ)
    public persistenceService: AssignUserPersistenceService
  ) {}
  filterOptions(search: string): Observable<Assignee[]> {
    return this.configService.allUsers.pipe(
      filter((users) => !!users),
      map((users) =>
        users
          .filter((user) => [999, 101].indexOf(user.id) === -1) // filter out system users
          .filter(
            (user) =>
              !search ||
              !search.toLowerCase ||
              user.name.toLowerCase().includes(search.toLowerCase())
          )
          .map((user) => ({ label: user.name, value: user.id }))
      )
    );
  }
  getAssignees() {
    return this.configService.allUsers.pipe(
      map((users) =>
        users.map((user) => ({
          label: user.name,
          value: user.id
        }))
      )
    );
  }
  getSelectedAssignee(id: number) {
    return this.configService.allUsers.pipe(
      filter(Boolean),
      filter((users) => users.length > 0),
      map((users) => users.find((user) => user.id === id)),
      map((user) => ({ label: user.name, value: user.id })),
      take(1)
    );
  }

  saveAssignee(assignee: Assignee) {
    console.log('calling save this assignee', assignee);
    return this.persistenceService.saveAssignee(assignee);
  }

  removeAssignee() {
    return this.persistenceService.removeAssignee();
  }
}
